import { 
  AutoRefreshTokenService, 
  provideKeycloak, 
  UserActivityService, 
  withAutoRefreshToken 
} from 'keycloak-angular';
import { environment } from 'src/environments/environment';

export const keycloakInitializer = () =>
  environment.auth_enabled
    ? provideKeycloak({
        config: {
          url: environment.sso_url,
          realm: 'SDS',
          clientId: 'resourcepanorama-fe'
        },
        initOptions: environment.keycloak_init_options as any,
        features: [
          withAutoRefreshToken({
            onInactivityTimeout: 'logout',
            sessionTimeout: 600000000
          })
        ],
        providers: [AutoRefreshTokenService, UserActivityService]
      })
    : [];
